<div class="modal-wrapper">
  <div class="modal-header">
    <h2 class="h6_500 modal-title" mat-dialog-title>
      {{ title | translate }}
    </h2>
    <button mat-icon-button class="modal-close-button" (click)="onEventClose()" aria-label="Close" matRipple="false">
      <mat-icon fontSet="material-icons-outlined">close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="modal-content">
    <div class="modal-form">
      <mat-form-field
        *ngFor="let field of visibleFields"
        appearance="outline"
        class="single-select-input-field"
        [floatLabel]="'always'">
        <mat-label>{{ field.label | translate }}</mat-label>
        <mat-select
          [value]="formState[field.id] || []"
          multiple
          (selectionChange)="onFieldChange(field.id, $event.value)">
          <mat-option *ngFor="let option of getFieldOptions(field)" [value]="option">
            {{ getDisplayValue(field, option) }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="modal-actions">
    <common-buttons-outlined
      [label]="labelButtonCancel | translate"
      [iconPosition]="false"
      (output)="onEventCancel()">
    </common-buttons-outlined>

    <common-buttons-filled
      [label]="labelButtonSave | translate"
      [iconPosition]="false"
      [disabled]="isSaveDisabled()"
      (output)="onEventSave()">
    </common-buttons-filled>
  </mat-dialog-actions>
</div>
